var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import process from 'process';
import Cookies from 'universal-cookie';
import { signOut as signOutAmplify } from 'aws-amplify/auth';
import { serviceLinks, serviceLinksLocal } from '../constants/enums';
const cookies = new Cookies();
// const signOut = async (environment: any, redirect: boolean = true) => {
const signOut = (environment) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    yield signOutAmplify();
    // const truriskInvalidate = await cookies.get('trurisk_a');
    // if (!truriskInvalidate) {
    const cook = yield cookies.getAll();
    const keys = Object.keys(cook);
    keys.forEach((c) => {
        cookies.remove(c);
        cookies.remove(c, { domain: `.${environment.route}`, path: '/' });
        cookies.remove(c, { domain: environment.route, path: '/' });
    });
    // }
    // if (redirect) {
    const links = ((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.REACT_APP_STAGE) === 'local' ? serviceLinksLocal : serviceLinks;
    window.location.href = `${links[0]}logged-out`;
    // }
});
export default signOut;
